import Vue from 'vue'
import {
    Swipe,
    SwipeItem,
    Grid,
    GridItem,
    Row,
    Col,
    Button,
    Toast,
    Checkbox,
    Cell,
    CellGroup,
    Image,
    PasswordInput,
    NumberKeyboard,
    Dialog,
    Overlay,
    Field,
    Form,
    Tabbar,
    TabbarItem,
    Search,
    Icon,
    Card,
    Tag,
    NavBar,
} from 'vant';

// 使用组件
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Checkbox)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Image)
Vue.use(PasswordInput)
Vue.use(NumberKeyboard)
Vue.use(Dialog)
Vue.use(Overlay)
Vue.use(Field)
Vue.use(Form)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Search)
Vue.use(Icon)
Vue.use(Card)
Vue.use(Tag)
Vue.use(NavBar);

